// Single source of truth for design tokens.
// CommonJS so tailwind.config.js can require() it and TypeScript can import it
// (tsconfig.json sets allowJs: true).

const brand = {
  50: '#FAF9F8',   // page surfaces
  100: '#F0EDEB',  // subtle fills, desktop backdrop
  300: '#C4BCB8',  // borders
  600: '#6B615E',  // secondary text
  800: '#413B3B',  // primary — the app's existing brand colour
  900: '#2A2626',  // headings, bottom nav
};

const accent = {
  500: '#C8952F',  // active nav, highlights
  600: '#A87824',  // pressed
};

const semantic = {
  success: '#2E7D5B',
  warning: '#B8860B',
  danger: '#C0392B',
};

const radius = { sm: '6px', md: '10px', lg: '14px', full: '9999px' };

const fontSize = {
  xs: '12px',
  sm: '14px',
  base: '16px',
  lg: '18px',
  xl: '22px',
  '2xl': '28px',
};

const fontLineHeight = {
  xs: '16px',
  sm: '20px',
  base: '24px',
  lg: '26px',
  xl: '30px',
  '2xl': '36px',
};

const fontFamily = {
  // Body/UI. Roboto was declared without a webfont, so it only resolved on
  // platforms where Roboto is a system face (Android) and fell back
  // elsewhere. Name the platform faces explicitly so the fallback is a good
  // one rather than an accident.
  sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  // Headings and money figures only.
  display: "'Playfair Display', Georgia, 'Times New Roman', serif",
};

// Desktop-only heading steps, applied at lg and above.
const displayFontSize = {
  md: '34px',
  lg: '44px',
};

const displayLineHeight = {
  md: '40px',
  lg: '50px',
};

const shadow = {
  card: '0 1px 2px rgba(42,38,38,.06), 0 4px 12px rgba(42,38,38,.05)',
};

const layout = {
  maxWidth: '480px',
  containerMax: '1280px',
};

module.exports = { brand, accent, semantic, radius, fontSize, fontLineHeight, fontFamily, displayFontSize, displayLineHeight, shadow, layout };
